// Prices that change on a date (UTC), like the offers in api/_lib/offers.js:
// nothing needs a deploy when they do. Checkout charges priceOf(); each
// checkout's GET reports it, and the pages put it in their [data-price]
// spans, so the page and the charge always agree.
//
// The live wallpapers launch at $2.99 until 13 November 2026, then cost
// $4.99; the desktop bundle follows, $4.99 then $5.99; VR and AR mode is
// $2.99 until 13 December 2026, then $4.99. Products not listed
// keep the cents in PRODUCTS / BUNDLES (api/_lib/orders.js).
//
// Prices are US cents unless the product says otherwise: the star map print
// file (print-digital) is £19, in pence, and labelled in pounds.

export const PRICE_CHANGES = {
  wallpaper: [{ until: '2026-11-13T00:00:00Z', cents: 299 }, { cents: 499 }],
  // VR and AR mode keeps its $2.99 through its offer (13 November to 13
  // December, api/_lib/offers.js), then $4.99.
  xr: [{ until: '2026-12-13T00:00:00Z', cents: 299 }, { cents: 499 }],
  'bundle-desktop': [{ until: '2026-11-13T00:00:00Z', cents: 499 }, { cents: 599 }],
};

// '$2.99' for dollars (as every page has always shown them); other
// currencies drop the pence of a whole amount, so £19 reads '£19'.
const SYMBOLS = { usd: '$', gbp: '£', eur: '€' };
export function priceLabel(cents, currency = 'usd') {
  if (currency === 'usd') return `$${(cents / 100).toFixed(2)}`;
  const amount = cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100);
  return SYMBOLS[currency] ? `${SYMBOLS[currency]}${amount}` : `${amount} ${currency.toUpperCase()}`;
}

// { cents, currency, label, until, nextCents, nextLabel } for a product now;
// `until` and the next price only while a change is coming. `fallback` is
// the list price in cents (dollars), or a PRODUCTS entry { cents, currency }.
export function priceOf(product, fallback, now = new Date()) {
  const fallbackCents = typeof fallback === 'object' && fallback ? fallback.cents : fallback;
  const currency = (typeof fallback === 'object' && fallback && fallback.currency) || 'usd';
  const label = (cents) => priceLabel(cents, currency);
  const steps = PRICE_CHANGES[product];
  if (!steps) return { cents: fallbackCents, currency, label: label(fallbackCents), until: null, nextCents: null, nextLabel: null };
  const t = now.getTime();
  const i = steps.findIndex((s) => !s.until || t < Date.parse(s.until));
  const step = steps[i];
  const next = step.until ? steps[i + 1] : null;
  return {
    cents: step.cents,
    currency,
    label: label(step.cents),
    until: step.until || null,
    nextCents: next ? next.cents : null,
    nextLabel: next ? label(next.cents) : null,
  };
}
